import { render, staticRenderFns } from "./EditCompanyModal.vue?vue&type=template&id=099da270"
import script from "./EditCompanyModal.vue?vue&type=script&lang=js"
export * from "./EditCompanyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports